import { onCookieConsent, isConsentGranted, cookieCategory } from "features/cookieConsent/index";
import { deleteCookie } from "utilities/browser";

const resxclsaScriptId = 'resxclsaScript'; 

function addScript () {
	
	if (document.getElementById(resxclsaScriptId) === null) {

		// add Certona pixel tracking js
		const certonaScript = document.createElement('script');
		certonaScript.type = 'text/javascript';
		certonaScript.async = true;
		certonaScript.src = `/Scripts/_vendor/certona/resxclsa.js${window.resx.resourceversion}`;
		certonaScript.id = resxclsaScriptId;

		document.querySelector('head').appendChild(certonaScript);

	}

}

function removeScript () {
	
	const certonaScript = document.getElementById(resxclsaScriptId);
	if (certonaScript !== null) {

		window.document.head.removeChild(certonaScript);

	}

}

function createResxclsaScript () {

	onCookieConsent(cookieCategory.Functional, () => {

		addScript();

	}, () => { 

		removeScript();
		deleteCookie('ResonanceSegment');

	});

}

export default createResxclsaScript;
